import { useLicenseStore } from '@/stores/license'
import { useCompaniesStore } from '@/stores/companies'
import { useCompaniesListStore } from '@/stores/companiesList'
import { useCountriesStore } from '@/stores/countries'
import { useManagersStore } from '@/stores/managers'
import { useOrderModesStore } from '@/stores/orderModes'
import { useOrdersStore } from '@/stores/orders'
import { usePUMOrderStore } from '@/stores/pum'
import { usePartnersStore } from '@/stores/partners'
import { usePartnersListStore } from '@/stores/partnersList'
import { useRestaurantsStore } from '@/stores/restaurants'
import { useRestaurantInfoStore } from '@/stores/restaurantInfo'
import { useRolesStore } from '@/stores/roles'

/**
 * Resets all Pinia stores to their initial state
 * This should be called when the user logs out to clear all cached data
 */
export const resetAllStores = () => {
  useLicenseStore().reset()
  useCompaniesStore().reset()
  useCompaniesListStore().reset()
  useCountriesStore().reset()
  useManagersStore().reset()
  useOrderModesStore().reset()
  useOrdersStore().reset()
  usePUMOrderStore().reset()
  usePartnersStore().reset()
  usePartnersListStore().reset()
  useRestaurantsStore().reset()
  useRestaurantInfoStore().reset()
  useRolesStore().reset()
}
